 /*
Create By PRATAN : 2023-05-15
Update By Sittikron  : 09/08/2023 - เพิ่ม Permission ในการตรวจสอบ

Update By POOM : 26/01/2024  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
Update By POOM : 13/05/2024  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที
	


*/

import React, { useCallback, useEffect, useState, Fragment } from "react";
import { Helmet } from "react-helmet";
import { CP_CheckPermission } from "../Class/Class_Permission"
import Pathurl from "../Class/Pathurl.json";
import { useLocation } from "react-router-dom";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import {Class_ETC_MsgError,
        Class_ETC_MsgErrorfocusByID,
        Class_ETC_MsgSuccess,
        Class_ETC_Decrypt,
        Class_ETC_SessionTimeOut} from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
import ConfigETC from "../Class/ConfigETC.json";
import axios from "axios";

function M_staff_ae(props) {
  //#region __ Parameter __
  const location = useLocation();

  const [isFirst, setIsFirst] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [isLoadProgress, setIsLoadProgress] = useState(true);

  const [picture, setPicture] = useState(null);
  const [filepicture, setFilepicture] = useState(null);
  const [picture_str, setPicture_str] = useState(null);
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmShow, setConfirmShow] = useState(false);
  const [isStatus, setIsStatus] = useState(true);

  const [listPermission, setListPermission] = useState([]);
  const [listPermission_inactive, setListPermission_inactive] = useState([]);
  const [configData, setConfigData] = useState([]);

  const [valuePermission, setValuePermission] = useState("");
  const [pgAct, setPgAct] = useState("");
  const [ActShow, setActShow] = useState("");
  const [pgStaffCode, setPgStaffCode] = useState("");
  const [tagStaffCode, setTagStaffCode] = useState("");
  const [EditPergroup, setEditPergroup] = useState("");
  const [ isPicture, setIsPicture] = useState(true);
  const [ defaultPicture ] = useState("../dist/img/default-150x150.png");
  const [ defaultPicture_str ] = useState("Choose file");

  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);
  
  const [is_txt_firstname_eng, set_txt_firstname_eng] = useState("");
  const [is_txt_lastname_eng, set_txt_lastname_eng] = useState("");

  const [is_txt_firstname_th, set_txt_firstname_th] = useState("");
  const [is_txt_lastname_th, set_txt_lastname_th] = useState("");

  const [txtstaffcode, settxtstaffcode] = useState('');

  // eslint-disable-next-line
  const [max_staff, setMax_staff] = useState(0);
  // eslint-disable-next-line
  const [active_staff, setActive_staff] = useState(0);

  //#endregion

  useEffect(() => {
    if (isFirst === true) {
      GetParameter(function() {
        if (pgAct !== ""){  
          if(pgAct === "EditProfile"){
            GetConfig();
            if (isLoadedConfigData === true) {
                BindDDL(function (){
                  setPicture(defaultPicture);
                  setPicture_str(defaultPicture_str);
                  setIsPicture(true);
                  BindStaff(function(){
                    setIsLoadProgress(false);
                  });
                  setIsFirst(false);
                });
            } 
          }
          else{
            let isPerView = CP_CheckPermission("master" , ["staff_view"] , false , true);
            if (isPerView){
              let isPerAdd = false; 
              let isPerEdit = false;

              if(pgAct === "Add" )
              {
                isPerAdd = CP_CheckPermission("master" , ["staff_add"] , false , true);
                setIsPermissionAdd(isPerAdd);
              }
              else
              {
                isPerEdit = CP_CheckPermission("master" , ["staff_edit"] , false , false);
                setIsPermissionEdit(isPerEdit);
              }
              GetConfig();
              if (isLoadedConfigData === true) {
                BindDDL(function (){
                  BindService(function() {
                    setPicture(defaultPicture);
                    setPicture_str(defaultPicture_str);
                    setIsPicture(true);
                    if (pgAct === "Add") {
                      setValuePermission("-1");
                      setIsLoadProgress(false);
                    } else {
                      BindStaff(function(){
                        setIsLoadProgress(false);
                      });
                    }
                    setIsFirst(false);
                  });
                });
              }
            };
          }
        }
    });
  }
    // eslint-disable-next-line
  }, [isLoadedConfigData, pgAct]);

  //#region __ Bind __
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  function GetParameter(_callback) {
    let isNullParameter = false;
    let staff_code = "";
    let act = "";

    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        staff_code = Class_ETC_Decrypt(location.state?.staff_code.toString());
        act = Class_ETC_Decrypt(location.state?.act.toString());

        if (act === "") {
          isNullParameter = true;
        } else if (act !== "Add" && act !== "Edit" && act !== "EditProfile") {
          isNullParameter = true;
        } else {
          if (act === "Edit" && staff_code === "") {
            isNullParameter = true;
          }
          else if (act === "EditProfile" && staff_code === "") {
            isNullParameter = true;
          }
        }
      }
    } catch {
      isNullParameter = true;
    }

    if (isNullParameter) {
      window.location.replace("../" + Pathurl.m_staff);
      if (_callback != null) {
          _callback();
      }
    } else {
      setPgAct(act);
      setPgStaffCode(staff_code);
      let act_show = act === "Add" ? "Add" : "Edit";
      setActShow(act_show);
      if (_callback != null) {
          _callback();
      }
    }
  }

  async function BindDDL(_callback) {
    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    var raw = JSON.stringify({
      per_group_status: "1",
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(configData.API_URL + "Permission_Getlist", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status_ID === 1) {
          if (result.total_Data > 0) {
              setListPermission(result.data);
            } else {
              setListPermission([]);
            }
          if (_callback != null) {
            _callback();
          }
        }
        else if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else{
          setListPermission([]);
          if (_callback != null) {
            _callback();
          }
        }
      })
      .catch((error) => {
        setListPermission([]);
        if (_callback != null) {
          _callback();
        }
      });
      
  }

  async function BindService(_callback) {
    try {
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = ""

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ServiceInfo_GetDetail",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          // setMax_staff(10)
          // setActive_staff(10)
          setMax_staff(json.max_staff)
          setActive_staff(json.active_staff)
        } else {
          setMax_staff(0)
          setActive_staff(0)
        }
        if (_callback != null) {
          _callback();
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        setMax_staff(0)
        setActive_staff(0)
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setMax_staff(0)
      setActive_staff(0)
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindStaff(_callback) {
    try {
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        staff_code: pgStaffCode,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Staff_Getdata",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          settxtstaffcode(json.staff_code);
          set_txt_firstname_eng(json.staff_firstnameEng);
          set_txt_lastname_eng(json.staff_lastnameEng);
          set_txt_firstname_th(json.staff_firstnameTh);
          set_txt_lastname_th(json.staff_lastnameTh);
          document.getElementById("txt_phone").value = json.staff_phone;
          document.getElementById("txt_email").value = json.staff_email;
          if (json.per_group_status === 0) {
            setListPermission_inactive([
              { value: json.per_group_id, label: json.per_group_name },
            ]);
          }
          setEditPergroup(json.per_group_name);
          if(json.staff_img_profile === ""){
            setPicture(defaultPicture);
            let firstnameEng = json.staff_firstnameEng;
            let firstnameEngtouse = firstnameEng !== null ? firstnameEng.substring(0,1).toUpperCase() : "";
            setTagStaffCode(firstnameEngtouse);
            setIsPicture(false);
          }else{
            setPicture(json.staff_img_profile);
            setIsPicture(true);
          }
          document.getElementById("hd_img_profile").value = json.staff_img_profile_str;
          setIsStatus(json.staff_status === 1 ? true : false);
          setValuePermission(json.per_group_id.toString());

          document.getElementById("div_password").style = "display : none";
          document.getElementById("txt_staff_code").disabled = true;

          if (_callback != null) {
            _callback();
          }
        } else {
          Change_Page();
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else{
        Change_Page();
      }
    } catch(e) {
      // console.log(e);
      Change_Page();
    }
  }
  //#endregion

  //#region __ Image __
  const handleCreateBase64 = useCallback(async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
    if (!file.name.match(/\.(jpg|jpeg|png|gif)$/)) 
    {
      Class_ETC_MsgError(MsgDescription.ERR007, null);
    } 
    else if (file.size > 5242880) 
    {
      Class_ETC_MsgError(MsgDescription.ERR008, null);
    } 
    else 
    {
      setPicture(base64);
      setPicture_str(file.name);
      setFilepicture(file);
      setIsPicture(true);
    }

    e.target.value = "";
  }, []);
  
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) 
      {
        Class_ETC_MsgError(MsgDescription.ERR006, null);
      } 
      else 
      {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
      }
      fileReader.onerror = (error) => 
      {
        reject(error);
      };
    });
  };
  //#endregion

  const togglePassword = () => { setPasswordShow(!passwordShow); };
  const toggleConfirmPassword = () => { setConfirmShow(!confirmShow); };

  function Onclick_Save() {
    setIsLoadProgress(true);
    var istxtError = "";
    let isError = "";

    if(pgAct === "Add"){
      var txt_password = document.getElementById("txt_password").value.trim();
      var txt_confirm_password = document.getElementById("txt_confirm_password").value.trim();
    }
   
    var txt_email = document.getElementById("txt_email").value.trim();

    if (document.getElementById("txt_staff_code").value.trim() === "") 
    {
      istxtError = "txt_staff_code";
    } 
    else if (pgAct !== "EditProfile" && document.getElementById("ddl_permission_group").value === "-1") 
    {
      istxtError = "ddl_permission_group";
    } 
    else if (pgAct === "Add" && txt_password === "") 
    {
      istxtError = "txt_password";
    } 
    else if (pgAct === "Add" && txt_confirm_password === "") 
    {
      istxtError = "txt_confirm_password";
    }
    else if (document.getElementById("txt_firstname_eng").value.trim() === "")
    {
      istxtError = "txt_firstname_eng";
    } 
    else if (document.getElementById("txt_lastname_eng").value.trim() === "") 
    {
      istxtError = "txt_lastname_eng";
    } 
    

    if (istxtError !== "") 
    {
      isError = "Empty";
    }

    if (pgAct === "Add" && txt_password !== txt_confirm_password) 
    {
      istxtError = "txt_confirm_password";
      isError = "Pass";
    }

    if (txt_email !== "" && !txt_email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i))
     {
      istxtError = "txt_email";
      isError = "Email";
    }

    if (isError !== "") 
    {
      if (isError === "Empty") 
      {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError);
      } 
      else if (isError === "Pass") 
      {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID(MsgDescription.ERR010, istxtError);
      } 
      else if (isError === "Email") 
      {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID(MsgDescription.ERR011, istxtError);
      }
    } 
    else 
    {
      SaveStaff();
    }
  }

  function SaveStaff() {

    var txt_staff_code = document.getElementById("txt_staff_code").value.trim();
    if(pgAct === "Add"){
     var txt_password = document.getElementById("txt_password").value.trim(); 
    }
    var txt_firstname_th = document.getElementById("txt_firstname_th").value.trim();
    var txt_lastname_th = document.getElementById("txt_lastname_th").value.trim();
    var txt_firstname_eng = document.getElementById("txt_firstname_eng").value.trim();
    var txt_lastname_eng = document.getElementById("txt_lastname_eng").value.trim();
    var ddl_permission_group = pgAct !== "EditProfile" ? document.getElementById("ddl_permission_group").value.trim() : "EditProfile" ;
    var txt_phone = document.getElementById("txt_phone").value.trim();
    var txt_email = document.getElementById("txt_email").value.trim();

    const formData = new FormData();
    formData.append("staff_code",txt_staff_code === "" ? "" : txt_staff_code);
    if(pgAct === "Add"){
      formData.append("staff_password",txt_password === "" ? "" : txt_password);
    }
    formData.append("staff_firstnameTh",txt_firstname_th === "" ? "" : txt_firstname_th);
    formData.append("staff_lastnameTh",txt_lastname_th === "" ? "" : txt_lastname_th);
    formData.append("staff_firstnameEng",txt_firstname_eng === "" ? "" : txt_firstname_eng);
    formData.append("staff_lastnameEng",txt_lastname_eng === "" ? "" : txt_lastname_eng);
    formData.append("per_group_id",ddl_permission_group === "" ? "" : ddl_permission_group);
    formData.append("staff_phone", txt_phone === "" ? "" : txt_phone);
    formData.append("staff_email", txt_email === "" ? "" : txt_email);
    formData.append("staff_status", isStatus === true ? "1" : "0");
    if(pgAct === "Edit" || pgAct === "EditProfile"){
      var hd_img_profile = document.getElementById("hd_img_profile").value.trim();
      formData.append("staff_img_profile_str", hd_img_profile === "" ? "" : hd_img_profile);
    }
    formData.append("staff_img_profile",filepicture === null ? null : filepicture);

    let token = localStorage.getItem("TStoken");

    let config = 
    {
      method: "post",
      maxBodyLength: Infinity,
      url: configData.API_URL + (pgAct === "Add" ? "Staff_Add" :"Staff_Edit"),
      headers: {
        // 'Content-Type': 'application/json',
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
      data: formData,
      contentType: false, // Not to set any content header
      processData: false, // Not to process data
      async: false,
      traditional: true,
    };

    axios.request(config)
      .then((result) => {

        if (result.data.status_ID === 1) 
        {
          
          setIsLoadProgress(false);
          if(pgAct === "Add" || pgAct === "Edit" ){
            Class_ETC_MsgSuccess(MsgDescription.CFM001, Change_Page);
          }
          else{
            Class_ETC_MsgSuccess(MsgDescription.CFM001,null);
          }

        } 
        else if (result.data.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else 
        {
          
          setIsLoadProgress(false);
          Class_ETC_MsgError(result.data.status_Desc, null);
          
        }
      })
      .catch((error) => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR002, null);
      });
  }

  function Change_Page(){
    window.location.replace("../" + Pathurl.m_staff);
  }

  function onclick_Cancel(){
    setIsLoadProgress(true);
    setPasswordShow(false);
    setConfirmShow(false);
    
    if(pgAct === "Add"){
      document.getElementById("txt_staff_code").value = "";
      document.getElementById("txt_password").value = "";
      document.getElementById("txt_confirm_password").value = "";
      document.getElementById("txt_firstname_th").value = "";
      document.getElementById("txt_lastname_th").value = "";
      document.getElementById("txt_firstname_eng").value = "";
      document.getElementById("txt_lastname_eng").value = "";
      document.getElementById("txt_phone").value = "";
      document.getElementById("txt_email").value = "";
      document.getElementById("ddl_permission_group").value = "-1";
      setValuePermission("-1");
      setIsStatus(true)
      setPicture(defaultPicture);
      setPicture_str(defaultPicture_str);
      setIsPicture(true);
      setFilepicture(null);
      setIsLoadProgress(false);
    }else if (pgAct === "EditProfile"){
      BindStaff(function(){
        setPicture_str(defaultPicture_str);
        setIsLoadProgress(false);
      });
    }else{
      BindStaff(function(){
        document.getElementById("ddl_permission_group").value = valuePermission;
        setPicture_str(defaultPicture_str);
        setIsLoadProgress(false);

      });
    }

  }
  
  const textnameOnChangeTH = (event, inputName) => {
    const thaitext = /^[\u0E00-\u0E7F\s]+$/; // Thai Unicode range
    const newInputValueTH = event.target.value;
    
    if (!newInputValueTH.match(thaitext) && newInputValueTH !== '') {
      return; // Return early if there are non-Thai characters
    }

    if (inputName === 'txt_firstname_th') {
      set_txt_firstname_th(newInputValueTH);
    } else if (inputName === 'txt_lastname_th') {
      set_txt_lastname_th(newInputValueTH);
    }
  };


  const textnameOnChangeEng = (event, inputName) => {
    const englishTextRegex = /^[a-zA-Z\s]*$/;
    const newInputValueENG = event.target.value;

    if (!newInputValueENG.match(englishTextRegex) && newInputValueENG !== '') {
      return; 
    }

    if (inputName === 'txt_firstname_eng') {
      set_txt_firstname_eng(newInputValueENG);
    } else if (inputName === 'txt_lastname_eng') {
      set_txt_lastname_eng(newInputValueENG);
    }
  }

  const textnameOnChangeStaff = (event) => {
    const value = event.target.value;
    const validInput = /^[A-Za-z0-9@#._]*$/.test(value);
    //const validInput = /^[a-zA-Z0-9@#._]+$/.test(value);

    if (validInput) {
      settxtstaffcode(value);
    }
  };


  return (
    <>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      <Helmet>
        <title>{ActShow} Staff </title>
      </Helmet>
      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <h1 className="display-5">
                  {" "}
                  <i className="fa fa-user" /> {ActShow} Staff
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                {/* SELECT2 EXAMPLE */}
                {/* SELECT2 EXAMPLE */}
                <div className="card  shadow">
                  <div className="card-header">
                    <h3 className="card-title"> {ActShow} Staff</h3>
                    {/* <div class="float-right">
                            <a href="M_permission.html" class="btn btn-default btn-xs"  title="back" >
                            <i class="fas fa-arrow-left"></i> back
                          </a>
                          </div> */}
                  </div>
                  <div className="card-body">
                    {/* <div class="row">
                          <div class="col-md-10 offset-md-1"> */}
                    <div className="form-horizontal">
                    
                    <div className="row">
                      <div className="col-lg-6 col-12">
                        <div className="text-center">
                        <input type="hidden" id="hd_img_profile"></input>
                        {(isPicture === false && (
                            <>
                              <div
                                className="profile-user-img img-fluid img-circle img-bordered-sm bg-gray text-center"
                                style={{
                                  display: "inline-block",
                                  height: "100px",
                                  width: "100px",
                                  
                                }}
                              >
                                <i className="fa" title="logo" style={{fontSize: "55px",padding:"15px",}}>{tagStaffCode}</i>
                              </div> 
                            </>
                        ))
                        ||
                        (isPicture === true &&(
                          <>
                          <img
                            className="profile-user-img img-fluid img-circle"
                            src={picture}
                            id="img_staff_profile"
                            alt="logo"
                          />
                          </>

                        ))}
                        </div>
                      </div>
                      <div className="col-lg-6 col-12"></div>
                    </div>

                    <div className="row">
                      {/* คอลัมภ์ฝั่ง ซ้าย */}
                      <div className="col-lg-6 col-12">
                          <div className="form-group row pt-2">
                          <label className="text-sm col-sm-4 col-form-label text-right">
                            Picture
                          </label>
                          <div className="col-sm-8">
                            <div className="input-group">
                              <div className="custom-file">
                                <input
                                  id="exampleInputFile"
                                  type="file"
                                  className="custom-file-input form-control-sm"
                                  accept="image/*, png, jpeg, jpg, gif"
                                  onChange={handleCreateBase64}
                                />
                                <label className="custom-file-label">
                                  {picture_str}
                                </label>
                              </div>
                            </div>
                          </div>
                          </div>
                          <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Staff code<span className="text-danger">*</span>

                        </label>
                        
                        <div className="col-sm-8">
                       
                          <input
                            type="text"
                            value={txtstaffcode}
                            className="form-control form-control-sm"
                            onChange={textnameOnChangeStaff}
                            placeholder="Staff code(UserName)"
                            id="txt_staff_code"
                          />
                        </div>
                        </div>
                         <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Permission Group<span className="text-danger">*</span>
                        </label>
                        {pgAct === "EditProfile" ? (
                          <label className="text-sm col-sm-4 col-form-label text-left">
                              {EditPergroup}
                          </label>
                          ) : pgAct === "Add"  ? (

                            <div className="col-sm-8">
                            {valuePermission !== "" && (
                            <select
                              className="form-control form-control-sm"
                              style={{ width: "100%" }}
                              defaultValue={valuePermission}
                              id="ddl_permission_group"
                            >
                              <option value={"-1"}>{ConfigETC.ddl_pleaseselect}</option>
                              {
                                listPermission.length > 0 &&
                                  listPermission.map((list) => (
                                    <option
                                      key={list.per_group_id}
                                      value={list.per_group_id}
                                    >
                                      {list.per_group_name}
                                    </option>
                                  ))
                              }
                              {listPermission_inactive.length > 0 &&
                                  listPermission_inactive.map((list) => (
                                    <option key={list.value} value={list.value}>
                                      {list.label}
                                    </option>
                                  ))}
                            </select>
                            )}
                          </div>
                          ) : (
                          <>
                              <div className="col-sm-8">
                          {valuePermission !== "" && (
                          <select
                            className="form-control form-control-sm"
                            style={{ width: "100%" }}
                            defaultValue={valuePermission}
                            id="ddl_permission_group"
                          >
                            <option value={"-1"}>{ConfigETC.ddl_pleaseselect}</option>
                            {
                              listPermission.length > 0 &&
                                listPermission.map((list) => (
                                  <option
                                    key={list.per_group_id}
                                    value={list.per_group_id}
                                  >
                                    {list.per_group_name}
                                  </option>
                                ))
                            }
                            {listPermission_inactive.length > 0 &&
                                listPermission_inactive.map((list) => (
                                  <option key={list.value} value={list.value}>
                                    {list.label}
                                  </option>
                                ))}
                          </select>
                          )}
                        </div>
                          </>
                        )}
                        
                                              
                         </div>
                         <div  id="div_password">
                        <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-8">
                          <div className="input-group">
                            <input
                              type={passwordShow ? "text" : "password"}
                              className="form-control form-control-sm"
                              placeholder="Password"
                              id="txt_password"
                            />
                            <div className="input-group-append">
                              <button
                                type="submit"
                                className="btn btn-default btn-sm"
                                onClick={togglePassword}
                              >
                                <i
                                  className={
                                    passwordShow
                                      ? "fa fa-eye-slash"
                                      : "fa fa-eye"
                                  }
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                        Confirm Password <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-8">
                          <div className="input-group">
                            <input
                              type={confirmShow ? "text" : "password"}
                              className="form-control form-control-sm"
                              placeholder="Confirm Password"
                              id="txt_confirm_password"
                            />
                            <div className="input-group-append">
                              <button
                                type="submit"
                                className="btn btn-default btn-sm"
                                onClick={toggleConfirmPassword}
                              >
                                <i
                                  className={
                                    confirmShow
                                      ? "fa fa-eye-slash"
                                      : "fa fa-eye"
                                  }
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Firstname  (EN)<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Firstname"
                            value={is_txt_firstname_eng}
                            onChange={(event) => textnameOnChangeEng(event, 'txt_firstname_eng')}
                            id="txt_firstname_eng"
                          />
                        </div>
                        </div>
                        <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Lastname (EN)<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={is_txt_lastname_eng}
                            onChange={(event) => textnameOnChangeEng(event, 'txt_lastname_eng')}
                            placeholder="Lastname"
                            id="txt_lastname_eng"
                          />
                        </div>
                      </div>

                      </div>

                      {/* คอลัมภ์ฝั่ง ขวา */}
                      <div className="col-lg-6 col-12">

                      <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Firstname  (TH)
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            value={is_txt_firstname_th}
                            onChange={(event) => textnameOnChangeTH(event, 'txt_firstname_th')}
                            className="form-control form-control-sm"
                            placeholder="ชื่อ"
                            id="txt_firstname_th"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Lastname (TH)
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            value={is_txt_lastname_th}
                            onChange={(event) => textnameOnChangeTH(event, 'txt_lastname_th')}
                            className="form-control form-control-sm"
                            placeholder="นามสกุล"
                            id="txt_lastname_th"
                          />
                        </div>
                      </div>
                      
                      <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Mobile{" "}
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="tel"
                            className="form-control form-control-sm"
                            placeholder="Mobile"
                            id="txt_phone"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Email
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="email"
                            className="form-control form-control-sm"
                            placeholder="Email"
                            id="txt_email"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                       
                        <label className="text-sm col-sm-4 col-form-label text-right">
                          Status{" "}
                        </label>
                        <div className="col-sm-8" style={{margin:"auto"}}>


                        {pgAct === "EditProfile" ? 
                        (<>

                              <span 
                                className={
                                  isStatus === true
                                    ? ConfigETC.Status_active
                                    : ConfigETC.Status_inactive
                                }
                              >
                                {isStatus === true ? ConfigETC.SwitchButton_active_text : ConfigETC.SwitchButton_inactive_text}
                              </span>

                        </>)
                        :
                        (<>

                            <BootstrapSwitchButton
                              onChange={(checked) => {
                                setIsStatus(checked);
                              }}
                              checked={isStatus}
                              width={ConfigETC.SwitchButton_in_active_width} 
                              onlabel={ConfigETC.SwitchButton_active_text}
                              onstyle={ConfigETC.SwitchButton_active_color}
                              offlabel={ConfigETC.SwitchButton_inactive_text}
                              offstyle={ConfigETC.SwitchButton_inactive_color}
                              size="xs"
                            />
                        </>)
                      
                        }

                        </div>
                      </div>
                      </div>
                    </div>


                      <div className="form-group row">
                        <div className="col-sm-6">&nbsp;</div>
                        
                      </div>

                      
                      
                      
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer margin  ">
                    <a href="#!" 
                      className="btn btn-default "
                      title="Cancel"
                      onClick={() => onclick_Cancel()}>
                      <i className="fa  fa-times" /> Cancel
                    </a>
                    {(isPermissionAdd || isPermissionEdit || pgAct === "EditProfile" ) &&   
                      <a
                        href="#!"
                        className="btn btn-primary float-right"
                        title="Save"
                        onClick={() => Onclick_Save()}
                      >
                        <i className="fas  fa-save" /> Save
                      </a>
                    }
                  </div>
                  {/* end loading */}
                </div>
              </div>
            </div>
            {/* /.row (main row) */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default M_staff_ae;
